import { useEffect, useState } from "react";
import "./App.css";
import TaskForm from "./components/TaskForm";
import TaskList from "./components/TaskList";
import AuthForm from "./components/AuthForm";
import { getTasks, createTask, deleteTask, clearAuth, getStoredUser } from "./services/api";

function App() {
  const [tasks, setTasks] = useState([]);
  const [user, setUser] = useState(null);

  // restore user on refresh
  useEffect(() => {
    const storedUser = getStoredUser();
    if (storedUser) setUser(storedUser);
  }, []);

  // fetch tasks only when logged in
  useEffect(() => {
    if (!user) return;

    (async () => {
      try {
        const data = await getTasks();
        setTasks(data);
      } catch (err) {
        // token invalid/expired -> logout
        if (err.status === 401) {
          clearAuth();
          setUser(null);
          setTasks([]);
        }
      }
    })();
  }, [user]);

  const addTask = async (task) => {
    const newTask = await createTask(task);
    setTasks((prev) => [newTask, ...prev]);
  };

  const removeTask = async (id) => {
    await deleteTask(id);
    setTasks((prev) => prev.filter((t) => t._id !== id));
  };

  const logout = () => {
    clearAuth();
    setUser(null);
    setTasks([]);
  };

  return (
    <div className="App">
      <h1>Task Manager</h1>

      {!user ? (
        <>
          <p style={{ marginBottom: 24 }}>
            Please login to view your tasks.
          </p>
          <AuthForm onAuthed={setUser} />
        </>
      ) : (
        <>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <p style={{ marginBottom: 16 }}>
              Logged in as <strong>{user.email}</strong>
            </p>
            <button onClick={logout} style={{ width: "auto", padding: "12px 16px" }}>
              Logout
            </button>
          </div>

          <TaskForm onAdd={addTask} />
          <TaskList tasks={tasks} onDelete={removeTask} />
        </>
      )}
    </div>
  );
}

export default App;